import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

import { DangerousIcon } from 'icons';

export type ErrorSectionPropsT = {
  errorDetails?: string;
};

const ErrorSection: FC<ErrorSectionPropsT> = ({ errorDetails }) => (
  <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
    <DangerousIcon size="13xl" color="red" />
    <Typography align="center" variant="h6" color="text.primary">
      Something went wrong.
    </Typography>
    {errorDetails && (
      <Typography align="center" variant="body1" color="text.primary">
        {errorDetails}
      </Typography>
    )}
    <Typography align="center" variant="body1" color="text.secondary">
      Contact your warranty administrator at Warrcloud
    </Typography>
  </Box>
);

export default ErrorSection;
